<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data1" :height="tableHeight" size="small"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getOperatorInfoUrl" @listData='getDeviceData'></MyPage>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import searchForm from './personalComponent/searchForm.vue';
	import infoModal from './personalComponent/infoModal.vue';
	import webapi from '../../../webapi.js';
	export default {
		components: {
			searchForm,
			infoModal
		},
		data() {
			return {
				getOperatorInfoUrl: webapi.base_api_url + '/Archives/GetOperatorInfo',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				// //选择展示的充电站
				// SelectStation: "有家充电站",
				tableHeight: "650",
				BreadcrumbList: [this.$tt('系统管理'), '>>', this.$tt('个人信息')],
				//table标题数据
				columns1: [{
						title: this.$tt('运营商ID'),
						key: 'OperatorId',
						width: 100
					}, {
						title: this.$tt('运营商名称'),
						key: 'OperatorName',
						width: 200
					},
					{
						title: this.$tt('运营商电话1'),
						key: 'OperatorTel1',
						width: 120
					},
					{
						title: this.$tt('运营商电话2'),
						key: 'OperatorTel2',
						width: 120
					},
					{
						title: this.$tt('平台显示标题'),
						key: 'LogoTitle',
						width: 200
					},
					{
						title: this.$tt('平台显示logo图片'),
						key: 'LogoImg',
						width: 200,
						render: (h, params) => {
							return h('div',
								params.row.LogoImg
							);
						}
					},
					{
						title: this.$tt('ICP备案信息'),
						key: 'IcpNo',
						width: 200
					},
					{
						title: this.$tt('域名列表'),
						key: 'DomainName',
						width: 300
					}, {
						title: this.$tt('操作'),
						key: 'action',
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.getUpdateMessage(params.row.OperatorId)
										}
									}
								}, this.$tt('修改')) : h(),
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		//为了不误操作，确定取消相反
								// 		click: () => {
								// 			this.getUpdateMessage(params.row.OperatorId)
								// 		}
								// 		// this.show("deleteStation", params.row.Id)
								// 	}
								// }, this.$tt('查看')),
								// h('Dropdown', {
								// 		on: {
								// 			//为了不误操作，确定取消相反
								// 			'on-click': (name) => {
								// 				this.$Modal.confirm({
								// 					title: name,
								// 					okText: '取消',
								// 					cancelText: '确定',
								// 					onCancel: () => {
								// 						this.otherMethodStation(name, params.row.OperatorId);
								// 					}
								// 				});
								// 				// this.show("deleteStation", params.row.Id)
								// 			}
								// 		}
								// 	},
								// 	[
								// 		h('Button', {
								// 			props: {
								// 				type: 'primary',
								// 				size: 'small',
								// 			},
								// 			style: {
								// 				marginRight: '5px'
								// 			},
								// 		}, this.$tt('其他操作')),
								// 		h('DropdownMenu', {
								// 			slot: 'list'
								// 		}, [
								// 			this.methodList.map((item) => { // this.productTypeList下拉框里的data
								// 				return h('DropdownItem', {
								// 						props: {
								// 							name: item.Status
								// 						}
								// 					},
								// 					item.Status
								// 				)
								// 			})
								// 		])
								// 	],
								// )
							]);
						}
					}
				],
				methodList: [{
						id: 1,
						Status: this.$tt('建设中')
					}, {
						id: 5,
						Status: this.$tt('关闭下线')
					},
					{
						id: 6,
						Status: this.$tt('维护中')
					},
					{
						id: 50,
						Status: this.$tt('正常使用')
					}
				],
				data1: [],
				payValue: 0
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
			// this.SelectParam = this.$refs.MyTerm.formInline
			//this.uploadList = this.$refs.upload.fileList;
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	_this.$nextTick(() => {
			// 		 _this.SelectParam = this.$refs.MyTerm.formInline
			// 	})
			// 	return param
			// },
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			show: function(type, params) {
				this.$refs.ItemModal.show(type, params)
			},
			//查看详细信息
			getUpdateMessage: function(OperatorId) {
				console.log("修改查看运营商方法OperatorId" + OperatorId);
				const _this = this;
				let ItemData = {};
				for (let i = 0; i < _this.data1.length; i++) {
					if (_this.data1[i].OperatorId == OperatorId) {
						ItemData = Object.assign({}, _this.data1[i])
						_this.show('update', ItemData)
					}
				}
			},
			//删除修改之外的其他操作
			otherMethodStation: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).id
				console.log(typeNum)
				this.$axios.post(webapi.base_api_url + "/Archives/SetStationStatus2222", {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.code == 0) {
						this.$Message.info(name + this.$tt('成功'));
					}
				})
			},
			deleteStation: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Overview/###", {}).then(res => {
					if (res.data.code != 1 && res.data.Data != null) {
						this.$Message.info(this.$tt('删除成功'));
					}
				})
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
